import { createRouter, createWebHashHistory } from "vue-router";
import NoPageFound from "@/views/NoPageFoundView.vue";

import isAuthenticatedGuard from "@/modules/auth/router/auth-guard";
import isAdminGuard from "@/modules/auth/router/admin-guard";
import isUserGuard from "@/modules/auth/router/user-guard";

import OficialiaUsuarios from "../modules/usuario/views/oficialiaUsuario.vue";
import OficialiaAdjuntos from "../modules/usuario/views/oficialiaAdjuntos.vue";
import OficialiaUsuariosRouter from "../modules/usuario/router/index";
import OficialiaPrincipal from "../modules/oficialia/views/oficialiaOficios";
import OficialiaVBCCP from "../modules/oficialia/views/oficialiaVBCCP";
import OficialiaFirmar from "../modules/oficialia/views/oficialiaFirmaOficios";
import OficialiaOficios from "../modules/oficialia/views/oficialiaRecepcionOficios.vue";
import OficialiaArchivados from "../modules/oficialia/views/oficialiaArchivados";
import OficialiaMenu from "../modules/oficialia/views/oficialiaMenu";
import OficialiaTurnados from "../modules/oficialia/views/oficialiaTurnados";
import oficialiaCancelados from "../modules/oficialia/views/oficialiaCancelados";
import oficialiaFolios from "../modules/oficialia/views/oficialiaFolios";
import OficialiaRouter from "../modules/oficialia/router/index";
import OficialiaPassword from "../modules/auth/views/ChangePwView";
import UsuariosAdmin from "../modules/admin/views/oficialiaMenu.vue";
import { AdminRouter, OficialiaAdjuntosRouter } from "../modules/admin/router/index"
import OficialiaMinutario from "@/modules/oficialia/views/oficialiaMinutario.vue";
// import LeyendasView from "@/modules/admin/views/LeyendasView.vue";

const routes = [
  {
    path: "/",
    name: "login",
    component: () => import("@/modules/auth/views/LoginView.vue"),
  },
  {
    path: "/pw/:token",
    name: "pw",
    component: OficialiaPassword,
    props: route => ({ token: route.query.token })
  },
  {
    path: "/pw/",
    name: "pwalt",
    component: NoPageFound,
  },
  {
    path: "/oficialia",
    component: OficialiaMenu,
    beforeEnter: [isAuthenticatedGuard, isUserGuard],
    ...OficialiaRouter,
    children: [
      { name: 'menugeneral', path: "menugeneral", component: OficialiaMenu, },
      { name: 'creacion', path: "creacion/:tab", component: OficialiaPrincipal, props: route => ({ tab: route.query.tab }) },
      { name: 'vbccp', path: "vbccp/:tab", component: OficialiaVBCCP, props: route => ({ tab: route.query.tab }) },
      { name: 'firmas', path: "firmas/:tab", component: OficialiaFirmar, props: route => ({ tab: route.query.tab }) },
      { force: true, name: 'recepcion', path: "recepcion/:tab", component: OficialiaOficios, props: route => ({ tab: route.query.tab }) },
      { name: 'turnados', path: "turnados/:tab", component: OficialiaTurnados, props: route => ({ tab: route.query.tab }) },
      { name: 'archivados', path: "archivados/:tab", component: OficialiaArchivados, props: route => ({ tab: route.query.tab }) },
      { name: 'cancelados', path: "cancelados/:tab", component: oficialiaCancelados, props: route => ({ tab: route.query.tab }) },
      { name: 'folio', path: "folio/:tab", component: oficialiaFolios, props: route => ({ tab: route.query.tab }) },
      { name: "minutario", path: "minutario", component: OficialiaMinutario }
    ],
  },
  {
    path: "/usuarios",
    component: OficialiaUsuarios,
    beforeEnter: [isAuthenticatedGuard, isUserGuard],
    ...OficialiaUsuariosRouter,
  },
  {
    path: "/administrador",
    component: UsuariosAdmin,
    beforeEnter: [isAuthenticatedGuard, isAdminGuard],
    ...AdminRouter,
    // children:[
    //   {name:'leyendas', path:'leyendas', component:LeyendasView}
    // ]

  },
  {
    path: "/adjuntarOficilia",
    component: OficialiaAdjuntos,
    beforeEnter: [isAuthenticatedGuard, isUserGuard],
    ...OficialiaAdjuntosRouter,
  },
  {
    path: "/:pathMatch(.)",
    component: NoPageFound,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  linkActiveClass: "active",
});

export default router;